import { useEffect } from 'react';
import { Badge, Radio, Space, Spin } from 'antd';

import { useAvailableDeliveries } from 'Hooks';
import { DeliveryOptions, DemoFlows } from 'Types';

import './styles.scss';

interface Props {
  onChange: (delivery: DeliveryOptions) => void;
  option: DeliveryOptions;
  demoType: DemoFlows;
}

export function AvailableDeliveryTime({ onChange, option, demoType }: Props) {
  const [isLoading, availableDeliveries] = useAvailableDeliveries();

  useEffect(() => {
    if (isLoading) {
      return;
    }

    onChange(availableDeliveries[0]);
  }, [isLoading, availableDeliveries]);

  if (isLoading) {
    return (
      <div className="available-delivery-loader">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <Radio.Group className="available-delivery" value={option} onChange={(e) => onChange(e.target.value)}>
      <Space direction="vertical">
        {availableDeliveries.map((delivery, index) => (
          <Radio key={index} value={delivery}>
            <div title={(demoType === DemoFlows.ECommerce && delivery.fleet.name) as string}>
              {delivery.text}
              <Badge count={delivery.price ? `$${delivery.price}` : 'Free'} />
            </div>
          </Radio>
        ))}
      </Space>
    </Radio.Group>
  );
}
